import { AiFillGithub } from 'react-icons/ai'

export const GitTech = () => {
    return (
        <div>
        <AiFillGithub />
        <h4>Git</h4>
        </div>
    )
}